package tables.organization

import emotion.react.css
import entities.OrgProduct
import kotlinx.browser.window
import models.CategoryModel
import models.ProductModel
import org.w3c.fetch.RequestInit
import orgProductToJsonString
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.option
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.select
import react.useEffect
import react.useState
import token
import urlAddress
import web.cssom.*
import web.html.InputType
import web.http.Headers

external interface CreateOrgProductProps : Props {
    var idOrg: Int
    var isOpen: Boolean
    var listCategoryModel: List<CategoryModel>
    var onClose: () -> Unit
    var onUpdate: () -> Unit
}

val CreateOrgProductModal = FC<CreateOrgProductProps> { props ->
    if (props.isOpen) {
        val (productModels, setProductModels) = useState(emptyList<ProductModel>())
        val (lisFo, setFo) = useState(emptyList<String>())
        var status by useState("")
        var idCategory by useState(0)
        var idProduct by useState(0)
        var fo by useState("")
        var note by useState("")

        fun loadProducts(category: Int) {
            window.fetch(urlAddress + "api/product?category=$category", RequestInit(
                method = "GET",
                headers = web.http.Headers().apply {
                    append("Authorization", "Bearer $token")
                }
            ))
                .then { response -> response.json() }
                .then { data ->
                    val newResultList = (data as? Array<dynamic> ?: emptyArray()).mapNotNull {
                        ProductModel(
                            it.id as? Int ?: 0,
                            it.name as? String ?: "",
                            it.category as? String ?: ""
                        )
                    }
                    setProductModels(newResultList)
                }
        }

        fun loadFo() {
            window.fetch(urlAddress + "api/fo", RequestInit(
                method = "GET",
                headers = web.http.Headers().apply {
                    append("Authorization", "Bearer $token")
                }
            ))
                .then { response -> response.json() }
                .then { data ->
                    val newResultList = (data as? Array<dynamic> ?: emptyArray()).mapNotNull { it?.toString() }
                    setFo(newResultList)
                }
        }

        useEffect(lisFo.isEmpty()) {
            loadFo()
        }


        div {
            css {
                borderRadius = 10.px
                padding = 20.px
                position = Position.fixed
                top = 50.pct
                left = 50.pct
                transform = translate((-50).pct, (-50).pct)
                backgroundColor = rgb(142, 178, 170)
                display = Display.flex
                alignItems = AlignItems.center
                justifyContent = JustifyContent.center
            }

            div {
                p {
                    +"Категория:"
                }
                div {
                    select {
                        option {
                            value = 0
                            +""
                        }
                        props.listCategoryModel.forEach {
                            option {
                                value = it.id
                                +it.name
                            }
                        }
                        onChange = {
                            idCategory = it.target.value.toInt()
                            loadProducts(it.target.value.toInt())
                        }
                    }
                }

                p {
                    +"Продукт:"
                }
                div {
                    select {
                        option {
                            value = 0
                            +""
                        }
                        productModels.forEach {
                            option {
                                value = it.id
                                +it.name
                            }
                        }
                        onChange = {
                            idProduct = it.target.value.toInt()
                        }
                    }
                }

                p {
                    +"Федеральный округ:"
                }
                div {
                    select {
                        option {
                            +""
                        }
                        lisFo.forEach {
                            option {
                                +it
                            }
                        }
                        onChange = {
                            fo = it.target.value
                        }
                    }
                }
                p {
                    +"Вес/размер (Для числовых):"
                }
                input {
                    css {
                        fontSize = 14.px
                        width = 100.pct
                    }
                    value = note
                    type = InputType.text
                    onChange = { event ->
                        note = event.target.value
                    }
                }
                div {
                    css {
                        paddingTop = 20.px
                        display = Display.flex
                        justifyContent = JustifyContent.spaceAround
                    }
                    button {
                        +"Сохранить"
                        disabled = (idProduct == 0 || fo == "")
                        onClick = {
                            window.fetch(
                                urlAddress + "api/orgproduct", RequestInit(
                                    method = "POST",
                                    headers = Headers().apply {
                                        append("Authorization", "Bearer $token")
                                        append("Content-Type", "application/json")
                                    },
                                    body = orgProductToJsonString(
                                        OrgProduct(
                                            id = 0,
                                            prod_id = idProduct,
                                            org_id = props.idOrg,
                                            fo = fo,
                                            note = note
                                        )
                                    )
                                )
                            )
                                .then { response ->
                                    if (response.ok) {
                                        props.onClose()
                                        props.onUpdate()
                                    } else {
                                        status = "Ошибка"
                                    }
                                }
                        }
                    }
                    button {
                        +"Отмена"
                        onClick = {
                            props.onClose()
                        }
                    }
                }
                p {
                    +status
                }
            }
        }
    }
}

